interface HexLogoProps {
  size?: number;
  className?: string;
  variant?: "happy" | "surprised" | "filled";
}

export function HexLogo({ size = 48, className = "", variant = "happy" }: HexLogoProps) {
  if (variant === "filled") {
    return (
      <svg
        width={size}
        height={(size * 110) / 100}
        viewBox="0 0 100 110"
        className={className}
        aria-hidden="true"
      >
        <polygon
          points="50,5 90,28 90,77 50,100 10,77 10,28"
          fill="var(--brand-orange)"
        />
      </svg>
    );
  }

  if (variant === "surprised") {
    return (
      <svg
        width={size}
        height={(size * 110) / 100}
        viewBox="0 0 100 110"
        className={className}
        aria-hidden="true"
      >
        <polygon
          points="50,5 90,28 90,77 50,100 10,77 10,28"
          fill="none"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinejoin="round"
        />
        <line x1="50" y1="38" x2="50" y2="62" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
        <circle cx="50" cy="77" r="4" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={(size * 110) / 100}
      viewBox="0 0 100 110"
      className={className}
      aria-hidden="true"
    >
      <polygon
        points="50,5 90,28 90,77 50,100 10,77 10,28"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <circle cx="38" cy="50" r="4" fill="currentColor" />
      <circle cx="62" cy="50" r="4" fill="currentColor" />
      <path
        d="M36 66 Q50 78 64 66"
        stroke="currentColor"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
